var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYouTubeGlyphYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fdc308;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 48,
    height: 48
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.98,12.45c-.56-2.07-2.14-3.68-4.24-4.24-3.72-1.02-18.76-1.02-18.76-1.02,0,0-15.01,0-18.72,1.02-2.07.56-3.68,2.17-4.28,4.24-.98,3.72-.98,11.54-.98,11.54,0,0,0,7.82.98,11.57.6,2.03,2.21,3.68,4.28,4.24,3.72,1.02,18.72,1.02,18.72,1.02,0,0,15.04,0,18.76-1.02,2.1-.56,3.68-2.21,4.24-4.24,1.02-3.75,1.02-11.57,1.02-11.57,0,0,0-7.82-1.02-11.54ZM19.21,31.21v-14.41l12.45,7.19-12.45,7.22Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeGlyphYellow);
export default __webpack_public_path__ + "static/media/YouTube_Glyph_Yellow.7d82b11c81fd001728e454a1b7a93151.svg";
export { ForwardRef as ReactComponent };